import { render, staticRenderFns } from "./AssignmentManpower.vue?vue&type=template&id=18122d30&"
import script from "./AssignmentManpower.vue?vue&type=script&lang=js&"
export * from "./AssignmentManpower.vue?vue&type=script&lang=js&"
import style0 from "./AssignmentManpower.vue?vue&type=style&index=0&id=18122d30&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports